module.exports = __webpack_public_path__ + "img/20230628_185819.97412d31.jpeg";